import { render, staticRenderFns } from "./pointNew.vue?vue&type=template&id=3142e544&scoped=true&"
import script from "./pointNew.vue?vue&type=script&lang=js&"
export * from "./pointNew.vue?vue&type=script&lang=js&"
import style0 from "./pointNew.vue?vue&type=style&index=0&id=3142e544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3142e544",
  null
  
)

component.options.__file = "pointNew.vue"
export default component.exports